import React from "react";
import { Dialog, FlatButton, RaisedButton } from "material-ui";
import { Link } from "react-router";
import moment from "moment";
import { Table } from "reactable";

import config from "../config";
import * as util from "../util";

import GenericAnalyticsTable from "./partials/generic-analytics-table.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";
import UserStore from "../stores/UserStore";
import BallotUtil from "../utils/BallotUtil";

class BallotingExtremeAudit extends React.Component {
  constructor(props) {
    super(props);
    this.state = { votes: null };
  }

  static contextTypes = {
    router: React.PropTypes.object
  };

  componentWillMount() {
    BallotUtil.fetchConsolidatedAudit(
      UserStore.getState().apiKey,
      this.props.eventBucket.id
    )
      .then(data => {
        this.setState({ votes: data.votes });
      })
      .catch(e => window.alert(`Error fetching ballot audit: ${e.message}`));
  }

  getStyles() {
    return {
      header: {
        marginTop: "1em",
        marginBottom: 0
      }
    };
  }

  render() {
    const styles = this.getStyles();
    const { votes } = this.state;
    const name = UserStore.getState().data.name;

    if (!votes) {
      return <WorkingIndicator fullPage={true} />;
    }

    const rows = votes.map(v => {
      const formatted = v.votes.map(a => `${-(a.score - 5)}. ${a.name}`);

      return {
        name: v.person.name,
        email: v.person.email,
        voted_at: moment(v.voted_at).format("llll"),
        votes: {
          value: formatted.join("; "),
          label: (
            <span style={{ whiteSpace: "pre" }}>{formatted.join("\n")}</span>
          )
        }
      };
    });

    return (
      <div>
        <GenericAnalyticsTable
          csvLabel={`voting-log`}
          eventBucket={this.props.eventBucket}
          data={rows}
          columns={[
            { label: "Name", value: "name" },
            { label: "Email", value: "email" },
            { label: "Voted At", value: "voted_at" },
            { label: "Votes", value: "votes" }
          ]}
        />
      </div>
    );
  }
}

export default BallotingExtremeAudit;



// WEBPACK FOOTER //
// ./src/app/components/balloting-consolidated-audit.jsx